import React, { useState } from "react";

import { Box, Divider, Stack, Tab, Tabs as MuiTabs, type TabsProps } from "@mui/material";
import { type ResponsiveStyleValue } from "@mui/system";

export interface TabConfig {
  label: string;
  content: React.ReactNode;
  key: string;
}

interface TabsComponentProps {
  tabs: TabConfig[];
  variant?: TabsProps["variant"];
  spacing?: ResponsiveStyleValue<string | number> | undefined;
}

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`}>
    {value === index && <Box>{children}</Box>}
  </div>
);

const Tabs: React.FC<TabsComponentProps> = ({ tabs, variant = "standard", spacing }) => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={spacing} sx={{ width: "100%" }}>
      <Box>
        <MuiTabs value={value} onChange={handleChange} aria-label="dynamic tabs" variant={variant}>
          {tabs.map((tab) => (
            <Tab sx={{ textTransform: "none" }} key={tab.key} label={tab.label} />
          ))}
        </MuiTabs>
        <Divider />
      </Box>
      {tabs.map((tab, index) => (
        <TabPanel key={tab.key} value={value} index={index}>
          {tab.content}
        </TabPanel>
      ))}
    </Stack>
  );
};

export default Tabs;
